import {
    CLEARFILTER,
    SELECTEDAUTHOR,
    SELECTEDCATEGORY,
    TYPEDINPUT,
} from "./actionTypes";

export const selectedCategory = (category) => {
    return {
        type: SELECTEDCATEGORY,
        payload: category,
    };
};

export const selectedAuthor = (author) => {
    return {
        type: SELECTEDAUTHOR,
        payload: author,
    };
};

export const clearFilter = () => {
    return {
        type: CLEARFILTER,
    };
};

export const typedInput = (input) => {
    return {
        type: TYPEDINPUT,
        payload: input,
    };
};
